import { ensureCurrentUser } from '../util/data';

export const UserEvents = {
  USER_EVENT_FIRST_AVAILABILITY_UPDATED: 'USER_EVENT_FIRST_AVAILABILITY_UPDATED',
  USER_EVENT_FIRST_PROFILE_UPDATED: 'USER_EVENT_FIRST_PROFILE_UPDATED',
  USER_EVENT_FIRST_LISTING_SHARED: 'USER_EVENT_FIRST_LISTING_SHARED',
};

/**
 *
 * @param {Object} currentUser propTypes.currentUser
 * @param {String} event
 * @return {*}
 */
export const getUserEventFromCurrentUser = (currentUser, event) => {
  const ensuredCurrentUser = ensureCurrentUser(currentUser);
  const privateData = ensuredCurrentUser?.attributes?.profile?.privateData || {};
  return privateData?.[event];
};
